// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @font-face {
  font-family: "DaimlerCS-Regular";
  src: url("../../../src/assets/fonts/DaimlerCS-Regular.eot");
  src: url("../../../src/assets/fonts/DaimlerCS-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../../../src/assets/fonts/DaimlerCS-Regular.woff") format("woff"),
    url("../../../src/assets/fonts/DaimlerCS-Regular.ttf") format("truetype"),
    url("../../../src/assets/fonts/DaimlerCS-Regular.svg#svgFontName")
      format("svg");
} */

.main-container {
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: flex;
  background-color: black;
  padding-bottom: 20px;
}

.container-desktop {
  text-align: center;
  width: 75%;
  height: 15%;
  max-width: 1180px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: black;
  margin: 0 auto;
}

.container-tablet {
  width: 100%;
}

.container-phone {
  width: 350px;
}

.sample {
  color: white;
}

.img-container {
  height: 100%;
  width: 50%;
  text-align: left;
}

.logoContainer {
  display: flex;
  align-items: center;
}

.logo {
  width: 40px; /* Equivalent to 40px */
  height: auto;
  /* margin : 20px 0px 0px 40px; */
  margin-right: 3rem; 
  object-fit: contain;
}

.claim {
  width: 120px; /* Equivalent to 40px */
  height: auto;
  /* margin : 20px 0px 0px 40px; */
  object-fit: contain;
}

.logo-img {
  width: 100%;
  height: auto;
  /* margin: 2% auto auto 4%; */
}

.logo-img-phone {
  width: 90%;
}

.link-container {
  width: 50%;
  height: 100%;
  display: flex;
}

.link-stack {
  display: flex;
  margin: 4% 4% auto auto;
  align-items: center;
  flex-direction: row;
}

.link-image-home-page {
  margin-top: 0px;
  width: 13px;
  height: 15px;
  margin-left: 15px;
}

.link-image-phone {
  margin-right: 15px;
}

.homelink-name {
  color: white;
  margin-left: 7px;
  font-size: 14px;
  font-family: "DaimlerCS-Regular";
}

.homelink-name:hover {
  color: #3aabdb;
}

a:link {
  text-decoration: none;
}

.link-separator {
  border: solid 1px white;
  height: 17px;
  width: 3px;
  background-color: white;
  margin-left: 15px;
}

.button-stack {
  visibility: hidden;
}

.header-mb-img {
  filter: brightness(0.5);
  margin-top: -3px;
}

a {
  text-decoration: none;
}

a:link,
a:visited {
  color: #ffffff;
}

a:hover {
  color: #00adef;
}
a:hover img,
header-mb-img {
  color: #00adef;
  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(199deg)
    brightness(120%) contrast(120%);
}

@media screen and (max-width: 500px) {
 .logo {
    margin-right: 1.2rem;
 }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;;;;;;;;;GASG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,uBAAuB;EACpC,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,uBAAuB;EACrC,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd;mCACiC;AACnC;;AAEA;CACC;IACG,oBAAoB;CACvB;AACD","sourcesContent":["/* @font-face {\n  font-family: \"DaimlerCS-Regular\";\n  src: url(\"../../../src/assets/fonts/DaimlerCS-Regular.eot\");\n  src: url(\"../../../src/assets/fonts/DaimlerCS-Regular.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../../../src/assets/fonts/DaimlerCS-Regular.woff\") format(\"woff\"),\n    url(\"../../../src/assets/fonts/DaimlerCS-Regular.ttf\") format(\"truetype\"),\n    url(\"../../../src/assets/fonts/DaimlerCS-Regular.svg#svgFontName\")\n      format(\"svg\");\n} */\n\n.main-container {\n  width: 100%;\n  height: auto;\n  margin: 0 auto;\n  display: flex;\n  background-color: black;\n  padding-bottom: 20px;\n}\n\n.container-desktop {\n  text-align: center;\n  width: 75%;\n  height: 15%;\n  max-width: 1180px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background-color: black;\n  margin: 0 auto;\n}\n\n.container-tablet {\n  width: 100%;\n}\n\n.container-phone {\n  width: 350px;\n}\n\n.sample {\n  color: white;\n}\n\n.img-container {\n  height: 100%;\n  width: 50%;\n  text-align: left;\n}\n\n.logoContainer {\n  display: flex;\n  align-items: center;\n}\n\n.logo {\n  width: 40px; /* Equivalent to 40px */\n  height: auto;\n  /* margin : 20px 0px 0px 40px; */\n  margin-right: 3rem; \n  object-fit: contain;\n}\n\n.claim {\n  width: 120px; /* Equivalent to 40px */\n  height: auto;\n  /* margin : 20px 0px 0px 40px; */\n  object-fit: contain;\n}\n\n.logo-img {\n  width: 100%;\n  height: auto;\n  /* margin: 2% auto auto 4%; */\n}\n\n.logo-img-phone {\n  width: 90%;\n}\n\n.link-container {\n  width: 50%;\n  height: 100%;\n  display: flex;\n}\n\n.link-stack {\n  display: flex;\n  margin: 4% 4% auto auto;\n  align-items: center;\n  flex-direction: row;\n}\n\n.link-image-home-page {\n  margin-top: 0px;\n  width: 13px;\n  height: 15px;\n  margin-left: 15px;\n}\n\n.link-image-phone {\n  margin-right: 15px;\n}\n\n.homelink-name {\n  color: white;\n  margin-left: 7px;\n  font-size: 14px;\n  font-family: \"DaimlerCS-Regular\";\n}\n\n.homelink-name:hover {\n  color: #3aabdb;\n}\n\na:link {\n  text-decoration: none;\n}\n\n.link-separator {\n  border: solid 1px white;\n  height: 17px;\n  width: 3px;\n  background-color: white;\n  margin-left: 15px;\n}\n\n.button-stack {\n  visibility: hidden;\n}\n\n.header-mb-img {\n  filter: brightness(0.5);\n  margin-top: -3px;\n}\n\na {\n  text-decoration: none;\n}\n\na:link,\na:visited {\n  color: #ffffff;\n}\n\na:hover {\n  color: #00adef;\n}\na:hover img,\nheader-mb-img {\n  color: #00adef;\n  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(199deg)\n    brightness(120%) contrast(120%);\n}\n\n@media screen and (max-width: 500px) {\n .logo {\n    margin-right: 1.2rem;\n }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
